import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import SettingsTypes from '../types/SettingsTypes';
import { apiCredentialTypes, operationTypes } from '../../utils/Constants';

const initialState = {
  generalData: {},
  cashoutStatus: false,
  maintenanceFee: false,
  fxData: [],
  feeData: [],
  cashoutFeeData: [],
  tierData: [],
  cashinLimitData: [],
  cashoutLimitData: {},
  cashinCountries: [],
  scheduledSettlement: {},
  integrationDetails: {},
  chargebackFeeData: {},
  feeAmountRangeData: {},
  rollingReserveData: {},
};

export const Settings = handleActions(
  {
    [SettingsTypes.actions.fetchFxDataSuccess]: (state, { payload: { fxData } }) => {
      return {
        ...state,
        fxData,
      };
    },
    [SettingsTypes.actions.fetchScheduledSettlementSuccess]: (state, { payload: { scheduledSettlement } }) => {
      return {
        ...state,
        scheduledSettlement,
      };
    },
    [SettingsTypes.actions.fetchFeeDataSuccess]: (state, { payload: { feeData, tierData } }) => {
      return {
        ...state,
        feeData,
        tierData,
      };
    },
    [SettingsTypes.actions.fetchCashoutFeeDataSuccess]: (state, { payload: { cashoutFeeData } }) => {
      return {
        ...state,
        cashoutFeeData,
      };
    },
    [SettingsTypes.actions.fetchGeneralConfigSuccess]: (state, { payload: { generalData, cashoutStatus, maintenanceFee } }) => {
      return {
        ...state,
        generalData,
        cashoutStatus,
        maintenanceFee,
      };
    },
    [SettingsTypes.actions.fetchLimitsDataSuccess]: (state, { payload: { cashinLimitData, cashinCountries } }) => {
      return {
        ...state,
        cashinLimitData,
        cashinCountries,
      };
    },
    [SettingsTypes.actions.fetchCashoutLimitDataSuccess]: (state, { payload: { cashoutLimitData } }) => {
      return {
        ...state,
        cashoutLimitData,
      };
    },
    [SettingsTypes.actions.fetchIntegrationDetailsSuccess]: (state, { payload: { integrationDetails } }) => {
      return {
        ...state,
        integrationDetails,
      };
    },
    [SettingsTypes.actions.fetchChargebackFeeDataSuccess]: (state, { payload: { chargebackFeeData } }) => {
      return {
        ...state,
        chargebackFeeData,
      };
    },
    [SettingsTypes.actions.fetchReferralConfigSuccess]: (state, { payload: { referralConfigData } }) => {
      return {
        ...state,
        referralConfigData,
      };
    },
    [SettingsTypes.actions.generateApiKeySuccess]: (state, { payload: { apiKey, type } }) => {
      return {
        ...state,
        integrationDetails: {
          ...state.integrationDetails,
          productionCredentials: {
            login: type === apiCredentialTypes.CASHIN ? apiKey : state.integrationDetails.productionCredentials.login,
          },
          cashoutCredentials: {
            login: type === apiCredentialTypes.CASHOUT ? apiKey : state.integrationDetails.cashoutCredentials.login,
          },
          webPayStatusCredentials: {
            login: type === apiCredentialTypes.WEB_STATUS ? apiKey : state.integrationDetails.webPayStatusCredentials.login,
          },
        },
      };
    },
    [SettingsTypes.actions.fetchFeeAmountRangeDataSuccess]: (state, { payload: { feeAmountRangeData } }) => {
      return {
        ...state,
        feeAmountRangeData,
      };
    },
    [SettingsTypes.actions.fetchRollingReserveSuccess]: (state, { payload: { rollingReserveData } }) => {
      return {
        ...state,
        rollingReserveData,
      };
    },
  },
  initialState
);

const getSettings = (state) => state.Settings;

export const getGeneralData = createSelector(getSettings, (settings) => settings.generalData);

export const getIsCrossborderMerchant = createSelector(
  getSettings,
  (settings) => settings.generalData.operationType === operationTypes.INTERNATIONAL || !settings.generalData.operationType
);

export const getCashoutStatus = createSelector(getSettings, (settings) => settings.cashoutStatus);

export const getMaintenanceFee = createSelector(getSettings, (settings) => settings.maintenanceFee);

export const getFxData = createSelector(getSettings, (settings) => settings.fxData);

export const getScheduledSettlement = createSelector(getSettings, (settings) => settings.scheduledSettlement);

export const getFeeData = createSelector(getSettings, (settings) => settings.feeData);

export const getTierData = createSelector(getSettings, (settings) => settings.tierData);

export const getCashoutFeeData = createSelector(getSettings, (settings) => settings.cashoutFeeData);

export const getCashinLimitData = createSelector(getSettings, (settings) => settings.cashinLimitData);

export const getCashoutLimitData = createSelector(getSettings, (settings) => settings.cashoutLimitData);

export const getCashinCountries = createSelector(getSettings, (settings) => settings.cashinCountries);

export const getIntegrationDetails = createSelector(getSettings, (settings) => settings.integrationDetails);

export const getChargebackFeeData = createSelector(getSettings, (settings) => settings.chargebackFeeData);

export const getReferralConfig = createSelector(getSettings, (settings) => settings.referralConfigData);

export const getFeeAmountRangeData = createSelector(getSettings, (settings) => settings.feeAmountRangeData);

export const getRollingReserveData = createSelector(getSettings, (settings) => settings.rollingReserveData);
